import React, { FunctionComponent } from "react";
import { Result } from "antd";

const NotFound: FunctionComponent = () => <Result status="404" title="404" subTitle="您访问的页面不存在" />;

export default NotFound;
